<template>
  <div>
    <p>より快適に使用できますように、利用者の特性の設定をお願いします。</p>
    <SelectBox text="性別" :item-list=sexList @change-value="changeSex" />
    <SelectBox text="年代" :item-list=ageList @change-value="changeAge" />
    <SelectBox text="旅行目的" :item-list=purposeList @change-value="changePurpose" />
    <SelectBox text="同行者" :item-list=fellowList @change-value="changeFellow" />
    <SelectBox text="同行者の中に65才以上の高齢者がいますか？" :item-list=elderAnswerList @change-value="changeElderFellow" />
    <TextLink text="設定する" :disable="!selectedCheck" @click-text="onClickOk" />
    <p v-if="isTest" class="text-red">テスト版</p>
    <InputBox text="コメント欄" @change-value="changeComment" />
  </div>
</template>

<script>
import { SEX_LIST, AGE_LIST, PURPOSE_LIST, FELLOW_LIST, YES_NO_LIST } from '../../const.js'
import TitleArea from '@/components/Atoms/TitleArea'
import TextLink from '@/components/Atoms/TextLink'
import SelectBox from '@/components/Atoms/SelectBox'
import InputBox from '@/components/Atoms/InputBox'

export default {
  name: 'input-user-settings',
  components: {
    TitleArea,
    TextLink,
    SelectBox,
    InputBox
  },
  props: {
    isTest: { type: Boolean }
  },
  computed: {
    sexList () { return SEX_LIST },
    ageList () { return AGE_LIST },
    purposeList () { return PURPOSE_LIST },
    fellowList () { return FELLOW_LIST },
    elderAnswerList () { return YES_NO_LIST },
    selectedCheck () {
      return !!(this.selectedSex && this.selectedAge && this.selectedPurpose && this.selectedFellow && this.selectedElderFellow)
    }
  },
  data () {
    return {
      selectedSex: '',
      selectedAge: '',
      selectedPurpose: '',
      selectedFellow: '',
      selectedElderFellow: '',
      comment: ''
    }
  },
  methods: {
    changeSex (e) {
      this.selectedSex = e.ans
    },
    changeAge (e) {
      this.selectedAge = e.ans
    },
    changePurpose (e) {
      this.selectedPurpose = e.ans
    },
    changeFellow (e) {
      this.selectedFellow = e.ans
    },
    changeElderFellow (e) {
      this.selectedElderFellow = e.ans
    },
    changeComment (e) {
      let text = e
      if (e === undefined) {
        text = ''
      }
      this.comment = text
    },
    onClickOk () {
      this.$emit('click-ok', {
        'sex': this.selectedSex,
        'age': this.selectedAge,
        'purpose': this.selectedPurpose,
        'fellow': this.selectedFellow,
        'elder_fellow': this.selectedElderFellow,
        'comment': this.comment
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';
.text-red{
  color: $red;
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/InputUserSettings.vue